module.exports = __webpack_public_path__ + "static/media/character-01.04a032ef.png";